import GlobalVariables from './widgets/core/GlobalVariables';
import { ensureTracking } from './widgets/core/hooks/ensureTracking';
import { LogLevel } from './widgets/core/enums/Enum';
import getCurrentFormatedDateTime from './widgets/core/hooks/getCurrentFormatedDateTime';
import WebStorage from './widgets/core/hooks/WebStorage';
import AnalyticsEvents from './widgets/core/enums/AnalyticsEvents';
import AnalyticsCategories from './widgets/core/enums/AnalyticsCategories';
import TrackData from './widgets/core/hooks/TrackData';
import log from './widgets/core/hooks/log';
import deleteAllCookies from './widgets/core/hooks/deleteAllCookies';
// trivial event system
if (!window.ApexChat) {
    window.ApexChat = {};
}
ApexChat.scriptsLoaded = true;
ApexChat.AIResponseReceived = true;
ApexChat.getCurrentFormatedDateTime = getCurrentFormatedDateTime;
// from http://www.crockford.com/javascript/inheritance.html#sugar
Function.prototype.method = function (name, func) {
    this.prototype[name] = func;
    return this;
};

Function.method('bind2', function (scope) {
    const me = this;
    const args = Array.prototype.slice.apply(arguments, [1]);

    return function () {
        const handlerArgs = [];

        for (var i = 0; i < arguments.length; i++) {
            handlerArgs.push(arguments[i]);
        }
        for (i = 0; i < args.length; i++) {
            handlerArgs.push(args[i]);
        }

        return me.apply(scope, handlerArgs);
    };
});

ApexChat.toggleChevrons = false;
// default
ApexChat.currentLogLevel = GlobalVariables.ApexChatDefaultLogLevel || LogLevel.Error;

ApexChat.gaLinker = '_ga='; // default
ApexChat.gaClientId = ''; // default
ApexChat.gaDebug = false; // window.location.hostname == 'localhost' ? true : false;

// try it immediately to attempt setting it up
ensureTracking();

ApexChat.getPreloadedChatOptions = function () {
    return preloadedChatOptions;
};
let preloadedChatOptions;
let preloadedFormOptions;
let started;
const preloadedVisitorFormOptions = false;

ApexChat.getPreloadedVisitorFormOptions = function () {
    return preloadedVisitorFormOptions;
};
ApexChat.chatStartComplete = function (init) {
    // do not remove this function it's using by backend api
    if (!started) {
        try {
            if (init.isNewChat) {
                TrackData(AnalyticsCategories.Invitation, AnalyticsEvents.ChatStarted);
            } else {
                TrackData(AnalyticsCategories.Invitation, AnalyticsEvents.ChatRefreshed);
            }
        } catch (e) {
            // ApexChat.log(e);
        }

        try {
            startChatOptions = init;
            const chatOptionsModelData = ApexChat.getPreloadedChatOptions();
            if (chatOptionsModelData.isTemplateForVideo) {
                ApexChat.ChatRoom.renderVideoChat(chatOptionsModelData);
                ApexChat.ChatRoom.joinVideo(init);
            } else {
                ApexChat.ChatRoom.render(chatOptionsModelData);
                ApexChat.ChatRoom.join(init);
            }
        } catch (e) {
            log(e);
        }
    }
};

ApexChat.getPreloadedFormOptions = function () {
    return preloadedFormOptions;
};
ApexChat.elementsThatHaveBeenReset = {};

// THE FOLLOWING FUNCTION IS USING IN ASP.NET CORE API, PLEASE DON'T REMOVE IT REFERENCE
ApexChat.chatPreloadComplete = function (init) {
    preloadedChatOptions = init;
};
ApexChat.storageAPI = WebStorage();
ApexChat.localStorageAPI = WebStorage({ type: 'local' });
ApexChat.operatorNotAvailableMessage = 'The operator is not available at the moment.';
ApexChat.chatTransferSuccussMessage = 'The chat has successfully been transferred.';
ApexChat.closeWarningEnabled = true;

ApexChat.throttledFunctions = {};

ApexChat.getFormatedDay = function (format) {
    // todo: do not move this function as it's used in html templates
    return getCurrentFormatedDateTime(null, format ?? 'dd MMM dddd');
};

ApexChat.getRelativeDayLabel = function (format) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const current = new Date();
    current.setHours(0, 0, 0, 0);
    if (current.getTime() === today.getTime()) return 'Today';
    if (current.getTime() === yesterday.getTime()) return 'Yesterday';
    return ApexChat.getFormatedDay(format);
};

ApexChat.resetInvitationCookies = function (noReload, resetChatRelatedCookiesOnly) {
    //TODO: move these cookies to a global definition
    ApexChat.storageAPI.Remove('livechat_chat_id');
    ApexChat.storageAPI.Remove('livechat_server_chatid');
    if (!resetChatRelatedCookiesOnly) {
        ApexChat.storageAPI.Remove('livechat_invitation_closed');
        ApexChat.storageAPI.Remove('livechat_invitation_shown');
        ApexChat.storageAPI.Remove('livechat_visitor_history');
        ApexChat.storageAPI.Remove('livechat_visitor_id');
        ApexChat.storageAPI.Remove('livechat_agent_alias_id');
        ApexChat.storageAPI.Remove('livechat_operator_id');
        ApexChat.storageAPI.Remove('livechat_profile_id');

        ApexChat.storageAPI.Remove('livechat_exitpopup_in_progress');
        ApexChat.storageAPI.Remove('livechat_exitpopup_has_displayed');
        ApexChat.storageAPI.Remove('livechat_has_windowed_chat_started');
        ApexChat.storageAPI.Remove('livechat_exitpopup_is_closed');
        ApexChat.storageAPI.Remove('livechat_exitpopup_predefined_msg_sent');

        ApexChat.storageAPI.Remove('livechat_chat_in_progress');
        ApexChat.storageAPI.Remove('livechat_exitpopup_is_active');
        ApexChat.storageAPI.Remove('livechat_exitpopup_isMinimized');
        ApexChat.storageAPI.Remove('livechat_chat_state');
        ApexChat.storageAPI.Remove('livechat_ep_sound_enabled'); // Sound Icon Statemanagement
        sessionStorage.removeItem('livechat_is_page_reloaded');
        deleteAllCookies(); // FOR V3 and V2.
    }
    if (!noReload) {
        window.location.reload();
    }
};

ApexChat.animationArray = [];

ApexChat.TryParse = function (prop) {
    return typeof prop === 'string' ? JSON.parse(prop) : prop;
};
ApexChat.TryParseJSON = function (prop) {
    try {
        return JSON.parse(prop);
    } catch (error) {
        return prop;
    }
};